import { getTermRange, defineTerm, defineRange, resolveCycleWindow, resolveRangeOrdinal, resolveRangeDiff, resolveRangeFormat, logWarn, COMPASS, TermHook } from '@magmacomputing/tempo/plugin/sdk';
/** definition of meteorological season ranges */
const groups = defineRange([
    // Meteorological (North)
    { key: 'Spring', day: 1, month: 3, symbol: 'Flower', group: 'meteorological', sphere: COMPASS.North },
    { key: 'Summer', day: 1, month: 6, symbol: 'Sun', group: 'meteorological', sphere: COMPASS.North },
    { key: 'Autumn', day: 1, month: 9, symbol: 'Leaf', group: 'meteorological', sphere: COMPASS.North },
    { key: 'Winter', day: 1, month: 12, symbol: 'Snowflake', group: 'meteorological', sphere: COMPASS.North },
    // Meteorological (South)
    { key: 'Spring', day: 1, month: 9, symbol: 'Flower', group: 'meteorological', sphere: COMPASS.South },
    { key: 'Summer', day: 1, month: 12, symbol: 'Sun', group: 'meteorological', sphere: COMPASS.South },
    { key: 'Autumn', day: 1, month: 3, symbol: 'Leaf', group: 'meteorological', sphere: COMPASS.South },
    { key: 'Winter', day: 1, month: 6, symbol: 'Snowflake', group: 'meteorological', sphere: COMPASS.South },
], 'group', 'sphere');
/**
 * Resolves meteorological season candidates matching the configured hemisphere.
 *
 * @param t - The source Tempo instance
 * @param anchor - Optional reference time override
 * @returns Array of matching season term definitions
 * @internal
 */
function resolve(t, anchor) {
    if (t.sphere === undefined && anchor?.sphere === undefined) {
        logWarn(`[tempo] SeasonTerm requires 'sphere' configuration (e.g. Tempo.init({ sphere: 'north' }) or { sphere: 'south' }).`, t.config);
        return [];
    }
    const list = resolveCycleWindow(t, groups, { anchor, groupBy: ['group', 'sphere'], group: 'meteorological' });
    return list;
}
/**
 * ## SeasonTerm
 * Meteorological season
 */
export const SeasonTerm = defineTerm({
    key: 'szn',
    scope: 'season',
    description: 'Meteorological season',
    groups,
    resolve(anchor) {
        return resolve(this, anchor);
    },
    define(keyOnly, anchor) {
        return getTermRange(this, resolve(this, anchor), keyOnly, anchor);
    },
    [TermHook.ordinal](groups, anchor) {
        return resolveRangeOrdinal(this, groups, anchor);
    },
    [TermHook.diff](other, unit, tempo) {
        return resolveRangeDiff(this, other, unit, tempo);
    },
    [TermHook.format](token, tempo) {
        return resolveRangeFormat(this, token, tempo);
    }
});
